import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/programSlice";

import programApis from "src/api/program";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

// get program records saga
const GetProgramRecordsSaga = function* GetProgramRecordsSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      programApis.getProgramRecords,
      payload,
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getProgramRecordsSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getProgramRecordsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG,
      ),
    );
    reject(error);
  }
};

// upload program records saga
const UploadProgramRecordsSaga = function* UploadProgramRecordsSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      programApis.uploadProgramsRecords,
      payload,
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.uploadProgramRecordsSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.uploadProgramRecordsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG,
      ),
    );
    reject(error);
  }
};

// get program details (GoodFlip Care) saga
const GetProgramDetailsGfcSaga = function* GetProgramDetailsGfcSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      programApis.getProgramDetailsGfc,
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getProgramDetailsGfcSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getProgramDetailsGfcError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG,
      ),
    );
    reject(error);
  }
};

// claim a milestone benefit saga
const BenefitActionSaga = function* BenefitActionSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      programApis.benefitAction,
      payload,
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.benefitActionSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.benefitActionError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG,
      ),
    );
    reject(error);
  }
};

export default function* programSaga() {
  yield all([
    takeEvery(actions.getProgramRecordsRequest, GetProgramRecordsSaga),
    takeEvery(actions.uploadProgramRecordsRequest, UploadProgramRecordsSaga),
    takeEvery(actions.getProgramDetailsGfcRequest, GetProgramDetailsGfcSaga),
    takeEvery(actions.benefitActionRequest, BenefitActionSaga),
  ]);
}
